import Flickity from './wwdevFlickity';

class FlickityCarousel {
	constructor(config) {
		this.config = Object.assign({
			scope: '.flickity-carousel',
		}, config);

		this.$scope = $(this.config.scope);

		if (this.$scope.length > 0) {
			this.init();
		}
	}

	init() {
		this.$scope.each(function (it, el) {
			let settings = this.defaultSettings();

			Object.keys($(el).data()).forEach(function (key) {
				Object.assign(settings, {[key]: $(el).data(key)});
			});

			new Flickity(el, settings);
		}.bind(this));
	}

	// Je kunt hier de standaard waardes aanpassen.
	defaultSettings() {
		return {
			cellAlign: 'left',
			contain: true,
			groupCells: true
		}
	}
}

export default FlickityCarousel;